import { Component, OnInit } from '@angular/core';
import {TenantService} from '../../../core/tenant/tenant.service';
import {TranslationService} from '../../../core/_base/layout';

@Component({
  selector: 'kt-info-dialog',
  templateUrl: './info-dialog.component.html',
  styleUrls: ['./info-dialog.component.scss']
})
export class InfoDialogComponent implements OnInit {

  constructor(
    public tenant: TenantService,
    private translations: TranslationService,
  ) { }

  ngOnInit(): void {
  }

  getCurrentLanguage() {
    return this.translations.getSelectedLanguage();
  }
}
